import CSelect from "@/components/main/form/CSelect";
import { IconUsersGroup } from "@tabler/icons-react";
import CompanySizes from "@/resources/company-sizes.json";
import t from "@/lib/localization";

const CompanySizeInput = ({ form, dictionary, clearable = false }) => {
  const companySizeItems = CompanySizes.map((item) => {
    return {
      value: item,
      label: t(dictionary.countEmployees, { count: item }),
    };
  });

  return (
    <CSelect
      clearable={clearable}
      data={companySizeItems}
      placeholder={dictionary.size}
      className="mt-3"
      icon={<IconUsersGroup />}
      {...form.getInputProps("size")}
    />
  );
};

export default CompanySizeInput;
